export function accountLoadMessage(error) {
  if (String(error?.code || '').includes('permission-denied')) {
    return 'Your account access could not be confirmed. Please contact your administrator to review your account setup.';
  }
  return 'Your account could not be loaded. Please try signing in again. If the problem continues, contact your administrator.';
}
